import Carousel from "react-bootstrap/Carousel";
import "./Carosell.css";

function IndividualIntervalsExample() {
  return (
    <Carousel controls={false} indicators={false} fade>
      <Carousel.Item interval={2000}>
        <img className="d-block w-100 custom-carousel-height" src="./img/immagini/scalata.png" alt="Third slide" />
      </Carousel.Item>
      <Carousel.Item interval={2000}>
        <img className="d-block w-100 custom-carousel-height" src="./img/immagini/belvedere.png" alt="Third slide" />
      </Carousel.Item>
      <Carousel.Item interval={2000}>
        <img className="d-block w-100 custom-carousel-height" src="./img/immagini/gorropu.jpg" alt="First slide" />
      </Carousel.Item>
      <Carousel.Item interval={2000}>
        <img className="d-block w-100 custom-carousel-height" src="./img/immagini/panorama.jpg" alt="Second slide" />
      </Carousel.Item>
      <Carousel.Item interval={2000}>
        <img className="d-block w-100 custom-carousel-height" src="./img/immagini/strada.png" alt="Second slide" />
      </Carousel.Item>
    </Carousel>
  );
}

export default IndividualIntervalsExample;
